import * as React from 'react';

import { useParams } from 'js/lib/useRouter';

import EnterpriseOrgScopedLearningPathBreadcrumbs from 'bundles/enterprise-learning-path-description-page/modules/EnterpriseOrgScopedLearningPathBreadcrumbs';
import type { EnterpriseLearningPathPageFieldsFragment } from 'bundles/enterprise-learning-path-description-page/queries/__generated__/EnterpriseLearningPathPageFragments';
import { useThirdPartyOrganization } from 'bundles/unified-common/contexts/org-scoped/ThirdPartyOrganizationContext';
import BreadcrumbsModule from 'bundles/unified-description-page-common/components/modules/breadcrumbs/BreadcrumbsModule';

type Props = {
  pageData: EnterpriseLearningPathPageFieldsFragment;
};

const EnterpriseOrgScopedLearningPathBreadcrumbsModuleRenderer = ({ pageData }: Props) => {
  const thirdPartyOrganization = useThirdPartyOrganization();
  const { orgSlug, badgeTemplateSlug } = useParams();

  if (!orgSlug || !badgeTemplateSlug || !thirdPartyOrganization || !pageData.enterpriseBadge) {
    return null;
  }

  return <BreadcrumbsModule breadcrumbs={<EnterpriseOrgScopedLearningPathBreadcrumbs orgSlug={orgSlug} />} />;
};

export default EnterpriseOrgScopedLearningPathBreadcrumbsModuleRenderer;
